export enum ArticleSortOptionEnum {
  DEFAULT = 0,
  VIEWS = 1,
  ARTICLETYPE = 2,
  DATE = 3
}
